<div class="flex flex-col max-width-lg">
  <div class="flex flex-row justify-start items-center mb-56">
    <div *ngIf="showTitle" class="flex flex-auto mat-display-1 mb-0">{{'MY_SERVICES.TITLE' | transloco}}</div>
    <div class="flex flex-row flex-wrap gap-x-6 mr-40">
      <button (click)="clearFilter()" [ngClass]="{ 'active' : filters.size === 0 }" class="btn-link mt-6">
        {{ 'SANDBOX.ALL' | transloco }} ({{ totalCount }})
      </button>
      <button (click)="selectFilter(status)" *ngFor="let status of serviceStatuses"
              [ngClass]="{ 'active' : filters.has(status) }"
              class="btn-link mt-6">
        <ng-container>
          {{ 'SERVICE_STATUS.FILTER.' + status | transloco }} ({{ statusToCount.get(status) || 0 }})
        </ng-container>
      </button>
    </div>

    <span *ngIf="!showTitle" class="flex-auto"></span>

    <button [routerLink]="['/', tenant, 'catalogue']" class="flex items-center accent">
      <mat-icon svgIcon="add" class="icon-md mt-2"></mat-icon>
      <span>{{'MY_SERVICES.NEW_SERVICE' | transloco}}</span>
    </button>
  </div>

  <div class="flex flex-row flex-wrap">
    <app-card *ngFor="let cardInfo of filteredCardInfos"
              [serviceCardInfo]="cardInfo"
              [style.max-width.%]="23"
              class="mr-24 mb-48">
    </app-card>
  </div>
</div>
